module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Night-fog-418e309632ccc93b15baef7f59988b65.svg";